'use strict';

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const React = require('react');
const components_navigation_Link_Link = require('../Link/Link.cjs.js');
const components_navigation_PageNavigation_PageNavigationContext = require('./PageNavigationContext.cjs.js');

const link = "_link_1ubx8_1";
const row = "_row_1ubx8_12";
const styles = {
	link: link,
	row: row
};

function PageNavigationRow({ content: Content, isSelectable = true, item, nestedList: Children, onSelect }) {
  const [hover, setHover] = React.useState(false);
  const context = React.useContext(components_navigation_PageNavigation_PageNavigationContext);
  const { id, setId } = context;
  const selected = item.id === id;
  const handleOnSelect = React.useCallback((event) => {
    if (onSelect) {
      const itemWithNoChildren = tslib_es6.__rest(item, ["children"]);
      onSelect(itemWithNoChildren, event);
    }
    if (isSelectable) {
      setId(item.id);
    }
  }, [isSelectable, item, onSelect, setId]);
  const linkContent = React.useMemo(() => item.href ? jsxRuntime.jsx(components_navigation_Link_Link.Link, { className: styles.link, href: item.href, onBlur: () => setHover(false), onClick: (e) => {
    handleOnSelect(e);
    e.stopPropagation();
  }, onKeyDown: (e) => {
    if (e.key === "Enter") {
      handleOnSelect(e);
      e.stopPropagation();
    } else if (e.key === " ") {
      e.preventDefault();
    }
  }, onFocus: () => setHover(true), onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), children: jsxRuntime.jsx(Content, { hover, selected }) }) : jsxRuntime.jsx("div", { "aria-label": item.title, className: styles.row, "data-zds": true, onBlur: () => setHover(false), onClick: (e) => handleOnSelect(e), onFocus: () => setHover(true), onKeyDown: (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleOnSelect(e);
    }
  }, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), role: "button", tabIndex: 0, children: jsxRuntime.jsx(Content, { hover, selected }) }), [handleOnSelect, hover, item.href, item.title, selected]);
  return jsxRuntime.jsxs("li", { "data-zds": true, children: [linkContent, Children && jsxRuntime.jsx(Children, {})] });
}

module.exports = PageNavigationRow;
//# sourceMappingURL=PageNavigationRow.cjs.js.map
